import React, { useEffect, useState } from 'react'
import { Typography, Button } from 'antd'

import Background from "../../../Assets/background.avif"
import PKcloseImg from "../../../Assets/pokeball_close.png"
import PKopenImg from "../../../Assets/pokeball_open.png"

import Confetti from 'react-confetti'

import {
    Container,
    PokeBallClose,
    PokeBallOpen,
    CardLoot,
    ButtonContainer,
    BlinkDiv
} from "./styles"
import {  useLocation, useNavigate } from "react-router-dom";
const { Title } = Typography;

export const Gashapon = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false)
    const location = useLocation();
    
    const { pokeNombre, pokeImagen } = location.state || {};

    // abre pokeboll
    setTimeout(() => {
            setOpen(true)
        }, 5000);

    return (
        <Container background={Background}>
            {
                open && 
                <CardLoot>
                    <img src={pokeImagen} style={{ width: "60vw"}}/>
                    <Title level={3}>{pokeNombre}</Title>
                </CardLoot>
            }
            {
                !open 
                ? <PokeBallClose src={PKcloseImg} /> 
                : <PokeBallOpen src={PKopenImg} /> 
            }
            {
                open && <BlinkDiv />
            }
            {
                open && 
                <Confetti
                  style={{ position: "absolute", zIndex: 12, width: "100vw", height: "100vh"}}
            
                  numberOfPieces={400}
                  recycle={false}
                />
            }
            {
                open && 
                <ButtonContainer>
                    <Button type="primary" onClick={() => navigate('/configuracion')}shape="round" size={"large"} style={{backgroundColor: "rgb(8, 179, 102)"}}>
                        Aceptar
                    </Button>
                </ButtonContainer>
            }
        </Container>
    )
}
